import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import CookieConsent from './components/common/CookieConsent';
import ScrollRestoration from './components/common/ScrollRestoration';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Tokenomics from './pages/Tokenomics';
import Documentation from './pages/Documentation';
import About from './pages/About';
import Contact from './pages/Contact';
import Roadmap from './pages/Roadmap';
import Press from './pages/Press';
import PressRelease from './pages/PressRelease';
import PressRelease2 from './pages/PressRelease2';
import PressRelease3 from './pages/PressRelease3';
import PressRelease4 from './pages/PressRelease4';
import PressRelease5 from './pages/PressRelease5';
import PressRelease6 from './pages/PressRelease6';
import MediaKit from './pages/MediaKit';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Disclaimers from './pages/Disclaimers';
import CookiePolicy from './pages/CookiePolicy';
import Ambassador from './pages/Ambassador';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-background font-inter overflow-x-hidden">
          <Navbar />
          <ScrollRestoration />
          <main className="pt-14">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/invest" element={<Tokenomics />} />
              <Route path="/faq" element={<Documentation />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/roadmap" element={<Roadmap />} />
              <Route path="/press" element={<Press />} />
              <Route path="/press/real-estate-investment-for-everyone" element={<PressRelease6 />} />
              <Route path="/press/yield-optimization-model" element={<PressRelease5 />} />
              <Route path="/press/colombian-market-strategy" element={<PressRelease4 />} />
              <Route path="/press/passive-income-application" element={<PressRelease3 />} />
              <Route path="/press/transform-high-yield-properties" element={<PressRelease2 />} />
              <Route path="/press/revolutionizing-real-estate-investment" element={<PressRelease />} />
              <Route path="/media-kit" element={<MediaKit />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/disclaimers" element={<Disclaimers />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/ambassador" element={<Ambassador />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
        </div>
      </Router>
    </HelmetProvider>
  );
}